import { createContext } from "react";

const QrPaymentContext = createContext();

export default QrPaymentContext;
